<template>
  <div class="flex">
    <nested-menu-tab-button :title="$t('company')" icon="icon-list" route="admin.management.company"></nested-menu-tab-button>
    &nbsp;
    <nested-menu-tab-button :title="$t('api_key')" icon="icon-lock" route="admin.management.apiKey"></nested-menu-tab-button>
    &nbsp;
    <nested-menu-tab-button :title="$t('manager')" icon="icon-user" route="admin.management.manager"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.Management.TabNav',
  components: {
    NestedMenuTabButton
  }
}
</script>

<style scoped>

</style>
